import { FETCH_SPOT_CONTACTS_OPP_MAP_FAILURE, FETCH_SPOT_CONTACTS_OPP_MAP_REQUEST, FETCH_SPOT_CONTACTS_OPP_MAP_SUCCESS } from "../../actions/targetedReachout/spotContactOppMapActions";

  const initialState = {
    spotContactOppMapLoading: true,
    spotContactOppMapData: [],
    spotContactOppMapError: null,
  };
  
  const spotContactOppMapReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SPOT_CONTACTS_OPP_MAP_REQUEST:
        return { ...state, spotContactOppMapLoading: true , payload: action.payload};
      case FETCH_SPOT_CONTACTS_OPP_MAP_SUCCESS:
        return { ...state, spotContactOppMapLoading: false, spotContactOppMapData: action.payload };
      case FETCH_SPOT_CONTACTS_OPP_MAP_FAILURE:
        return { ...state, spotContactOppMapLoading: false, spotContactOppMapError: action.payload };       
      default:
        return state;
    }
  };
  
  export default spotContactOppMapReducer;
  
